var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFile = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 11.76 15.68"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M0 1.96C0 .88.88 0 1.96 0h4.9v3.92c0 .54.44.98.98.98h3.92v8.82c0 1.08-.88 1.96-1.96 1.96H1.96C.88 15.68 0 14.8 0 13.72V1.96Zm11.76 1.96H7.84V0l3.92 3.92Z"
})));
export default SvgFile;